import arrayify from "../../helpers/arrayify"

const MG_CONTENT_IS_FETCHING = "MG_CONTENT_IS_FETCHING"
const MG_CONTENT_FETCHING_SUCCESS = "MG_CONTENT_FETCHING_SUCCESS"
const MG_CONTENT_FETCHING_ERROR = "MG_CONTENT_FETCHING_ERROR"
const MG_CONTENT_SET_DB_CURSOR = "MG_CONTENT_SET_DB_CURSOR"
const MG_CONTENT_SET_PAGE = "MG_CONTENT_SET_PAGE"
const SET_MG_CONTENT_TYPE = "SET_MG_CONTENT_TYPE"
const MC_SET_SHUFFLE = "MC_SET_SHUFFLE"
const MC_SET_QUESTION = "MC_SET_QUESTION"
const MC_SET_ANSWERS = "MC_SET_ANSWERS"
const MC_SET_ACTIVE_EDIT = "MC_SET_ACTIVE_EDIT"
const MC_SET_IS_SAVING = "MC_SET_IS_SAVING"
const MC_SAVING_SUCCESS = "MC_SAVING_SUCCESS"
const MC_SAVING_ERROR = "MC_SAVING_ERROR"
const MC_TOGGLE_MODAL = "MC_TOGGLE_MODAL"
const MC_SELECT_ACTIVE_ITEM = "MC_SELECT_ACTIVE_ITEM"
const MC_UNSELECT_ACTIVE_ITEM = "MC_UNSELECT_ACTIVE_ITEM"

const MC_IS_FETCHING_ONE_ITEM = "MC_IS_FETCHING_ONE_ITEM"
const MC_FETCHING_ONE_ITEM_SUCCESS = "MC_FETCHING_ONE_ITEM_SUCCESS"
const MC_FETCHING_ONE_ITEM_ERROR = "MC_FETCHING_ONE_ITEM_ERROR"
const MC_SET_ANSWER = "MC_SET_ANSWER"
const MC_SET_STARTING_LETTER = "MC_SET_STARTING_LETTER"
const MC_ADD_NODE_TAG = "MC_ADD_NODE_TAG"
const MC_DELETE_NODE_TAG = "MC_DELETE_NODE_TAG"
const MC_FETCHING_NODES = "MC_FETCHING_NODES"
const MC_FETCHING_NODES_SUCCESS = "MC_FETCHING_NODES_SUCCESS"
const MC_FETCHING_NODES_ERROR = "MC_FETCHING_NODES_ERROR"
const MC_ADDING_NEW_ITEM = "MC_ADDING_NEW_ITEM"
const MC_ADDING_NEW_ITEM_SUCCESS = "MC_ADDING_NEW_ITEM_SUCCESS"
const MC_ADDING_NEW_ITEM_ERROR = "MC_ADDING_NEW_ITEM_ERROR"
const MC_DELETING_ITEM = "MC_DELETING_ITEM"
const MC_DELETING_ITEM_SUCCESS = "MC_DELETING_ITEM_SUCCESS"
const MC_DELETING_ITEM_ERROR = "MC_DELETING_ITEM_ERROR"
const MC_SET_ITEM_TYPE = "MC_SET_ITEM_TYPE"
const MC_SET_PASSAGE = "MC_SET_PASSAGE"
const MC_FETCHING_PASSAGE = "MC_FETCHING_PASSAGE"
const MC_FETCHING_PASSAGE_SUCCESS = "MC_FETCHING_PASSAGE_SUCCESS"
const MC_FETCHING_PASSAGE_ERROR = "MC_FETCHING_PASSAGE_ERROR"

const MC_UPDATE_ITEMS = "MC_UPDATE_ITEMS"

export function fetchingPassage() {
  return {
    type: MC_FETCHING_PASSAGE
  }
}

export function fetchingPassageSuccess() {
  return {
    type: MC_FETCHING_PASSAGE_SUCCESS
  }
}

export function fetchingPassageError(error) {
  return {
    type: MC_FETCHING_PASSAGE_ERROR,
    error
  }
}

export function setShuffle(shuffle) {
  return {
    type: MC_SET_SHUFFLE,
    shuffle
  }
}

export function setQuestion(question) {
  return {
    type: MC_SET_QUESTION,
    question
  }
}

export function setAnswers(answers) {
  return {
    type: MC_SET_ANSWERS,
    answers
  }
}

export function setActiveEdit(activeEdit) {
  return {
    type: MC_SET_ACTIVE_EDIT,
    activeEdit
  }
}

export function setIsSaving() {
  return {
    type: MC_SET_IS_SAVING
  }
}

export function savingSuccess() {
  return {
    type: MC_SAVING_SUCCESS
  }
}

export function savingError(error) {
  return {
    type: MC_SAVING_ERROR,
    error
  }
}

export function toggleModal(modalOpen) {
  return {
    type: MC_TOGGLE_MODAL,
    modalOpen
  }
}

export function selectActiveItem(activeItem) {
  return {
    type: MC_SELECT_ACTIVE_ITEM,
    activeItem
  }
}

// Add, Edit or Remove Item
export function updateItems(operation, activeItem) {
  return {
    type: MC_UPDATE_ITEMS,
    operation,
    activeItem: { ...activeItem, noChanges: true }
  }
}

export function unselectActiveItem(activeItem) {
  return {
    type: MC_UNSELECT_ACTIVE_ITEM
  }
}

export function setIsFetching() {
  return {
    type: MG_CONTENT_IS_FETCHING
  }
}

export function fetchingSuccess(items) {
  return {
    type: MG_CONTENT_FETCHING_SUCCESS,
    items
  }
}

export function fetchingError(error) {
  return {
    type: MG_CONTENT_FETCHING_ERROR,
    error
  }
}

export function setDbCursor(cursor) {
  return {
    type: MG_CONTENT_SET_DB_CURSOR,
    cursor
  }
}

export function setPage(page) {
  return {
    type: MG_CONTENT_SET_PAGE,
    page
  }
}

export function setContentType(contentType) {
  return {
    type: SET_MG_CONTENT_TYPE,
    contentType
  }
}

export function isFetchingOneItem() {
  return {
    type: MC_IS_FETCHING_ONE_ITEM
  }
}

export function isFetchingOneItemSuccess() {
  return {
    type: MC_FETCHING_ONE_ITEM_SUCCESS
  }
}

export function isFetchingOneItemError(error) {
  return {
    type: MC_FETCHING_ONE_ITEM_ERROR,
    error
  }
}

export function setAnswer(index, answer) {
  return {
    type: MC_SET_ANSWER,
    index,
    answer
  }
}

export function setStartingLetter(letter) {
  return {
    type: MC_SET_STARTING_LETTER,
    letter
  }
}

export function addNodeTag(nodeId) {
  return {
    type: MC_ADD_NODE_TAG,
    nodeId
  }
}

export function deleteNodeTag(nodeId) {
  return {
    type: MC_DELETE_NODE_TAG,
    nodeId
  }
}

export function fetchingNodes() {
  return {
    type: MC_FETCHING_NODES
  }
}

export function fetchingNodesSuccess(nodes) {
  return {
    type: MC_FETCHING_NODES_SUCCESS,
    nodes
  }
}

export function fetchingNodesError(error) {
  return {
    type: MC_FETCHING_NODES_ERROR,
    error
  }
}

export function addingNewItem() {
  return {
    type: MC_ADDING_NEW_ITEM
  }
}

export function addingNewItemSuccess(newItem) {
  return {
    type: MC_ADDING_NEW_ITEM_SUCCESS,
    newItem
  }
}

export function addingNewItemError(error) {
  return {
    type: MC_ADDING_NEW_ITEM_ERROR,
    error
  }
}

export function deletingItem() {
  return {
    type: MC_DELETING_ITEM
  }
}

export function deletingItemSuccess() {
  return {
    type: MC_DELETING_ITEM_SUCCESS
  }
}

export function deletingItemError(error) {
  return {
    type: MC_DELETING_ITEM_ERROR,
    error
  }
}

export function setItemType(itemType) {
  return {
    type: MC_SET_ITEM_TYPE,
    itemType
  }
}

export function setPassage(passage) {
  return {
    type: MC_SET_PASSAGE,
    passage
  }
}

const initialState = {
  isFetching: false,
  error: "",
  cursor: "",
  page: 1,
  contentType: "Item",
  activeItemId: "",
  activeItem: {
    shuffle: false,
    startingLetter: "",
    nodeTags: null,
    answers: []
  },
  items: [],
  modalOpen: false,
  isFetchingOneItem: false,
  isFetchingOneItemError: "",
  nodes: null,
  isFetchingNodes: false,
  isAddingNewItem: false,
  isDeletingItem: false,
  isSettingItemType: false,
  isFetchingPassage: false
}

export function manageContent(state = initialState, action) {
  switch (action.type) {
    case MC_SET_PASSAGE:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          passage: action.passage
        }
      }

    case MG_CONTENT_IS_FETCHING:
      return {
        ...state,
        isFetching: true,
        error: ""
      }
    case MG_CONTENT_FETCHING_SUCCESS:
      const updatedActiveitem = {
        ...action?.items?.filter(
          item => item?.itemId == state?.activeItemId
        )?.[0]
      }
      if (updatedActiveitem)
        updatedActiveitem.answers = arrayify(updatedActiveitem.answers ?? {})

      return {
        ...state,
        isFetching: false,
        error: "",
        items: action.items,
        activeItem: { ...state.activeItem, ...updatedActiveitem }
      }
    case MG_CONTENT_FETCHING_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    case MG_CONTENT_SET_DB_CURSOR:
      return {
        ...state,
        cursor: action.cursor
      }
    case MG_CONTENT_SET_PAGE:
      return {
        ...state,
        page: action.page
      }
    case SET_MG_CONTENT_TYPE:
      return {
        ...state,
        contentType: action.contentType
      }
    case MC_SET_SHUFFLE:
      let startingLetter = action.shuffle ? "" : "a"
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          shuffle: action.shuffle,
          noChanges: false,
          startingLetter
        }
      }
    case MC_SET_QUESTION:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          question: action.question,
          noChanges: false
        }
      }
    case MC_SET_ANSWERS:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          answers: action.answers,
          noChanges: false
        }
      }
    case MC_SET_ACTIVE_EDIT:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          activeEdit: action.activeEdit,
          noChanges: false
        }
      }
    case MC_SET_IS_SAVING:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          isSaving: true,
          error: ""
        }
      }
    case MC_SAVING_SUCCESS:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          isSaving: false,
          error: "",
          noChanges: true
        }
      }
    case MC_SAVING_ERROR:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          isSaving: false,
          error: action.error
        }
      }
    case MC_TOGGLE_MODAL:
      return {
        ...state,
        modalOpen: action.modalOpen
      }
    case MC_SELECT_ACTIVE_ITEM:
      return {
        ...state,
        activeItemId: action.activeItem.itemId,
        activeItem: {
          ...action.activeItem,
          activeEdit: {
            type: "",
            index: "" // turn back to zero if it breaks things
          },
          isSaving: false,
          lastSaved: "",
          noChanges: false
        }
      }
    case MC_UPDATE_ITEMS:
      let updatedItems = []
      let updatedActiveItem = {
        shuffle: false,
        startingLetter: "",
        nodeTags: null
      }

      let { items } = state
      let { operation, activeItem } = action

      if (operation === "edit") {
        updatedActiveItem = activeItem
        updatedItems = items.map(item => {
          if (item.itemId === activeItem.itemId) return activeItem
          return item
        })
      } else if (operation === "create") {
        updatedActiveItem = { ...activeItem, noChanges: false }
        updatedItems = [activeItem, ...items]
      } else if (operation === "delete") {
        updatedItems = items.filter(item => item.itemId !== activeItem.itemId)
      }

      return {
        ...state,
        items: updatedItems,
        activeItem: updatedActiveItem
      }
    case MC_UNSELECT_ACTIVE_ITEM:
      return {
        ...state,
        activeItemId: "",
        activeItem: {
          shuffle: false,
          startingLetter: "",
          nodeTags: null
        }
      }
    case MC_IS_FETCHING_ONE_ITEM:
      return {
        ...state,
        isFetchingOneItem: true,
        isFetchingOneItemError: ""
      }
    case MC_FETCHING_ONE_ITEM_SUCCESS:
      return {
        ...state,
        isFetchingOneItem: false,
        isFetchingOneItemError: ""
      }
    case MC_FETCHING_ONE_ITEM_ERROR:
      return {
        ...state,
        isFetchingOneItem: false,
        isFetchingOneItemError: action.error
      }
    case MC_SET_ANSWER:
      let newAnswers = state.activeItem.answers.slice(0)
      newAnswers.splice(action.index, 1, action.answer)
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          answers: newAnswers,
          noChanges: false
        }
      }
    case MC_SET_STARTING_LETTER:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          startingLetter: action.letter,
          noChanges: false
        }
      }
    case MC_ADD_NODE_TAG:
      let newNodeTags = { [action.nodeId]: true }
      if (state.activeItem.nodeTags) {
        newNodeTags = {
          ...state.activeItem.nodeTags,
          [action.nodeId]: true
        }
      }
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          nodeTags: newNodeTags
        }
      }
    case MC_DELETE_NODE_TAG:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          nodeTags: {
            ...state.activeItem.nodeTags,
            [action.nodeId]: false
          }
        }
      }
    case MC_FETCHING_NODES:
      return {
        ...state,
        isFetching: true
      }
    case MC_FETCHING_NODES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        nodes: action.nodes
      }
    case MC_FETCHING_NODES_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    case MC_ADDING_NEW_ITEM:
      return {
        ...state,
        isAddingNewItem: true
      }
    case MC_ADDING_NEW_ITEM_SUCCESS:
      return {
        ...state,
        activeItemId: action.newItem.itemId,
        activeItem: action.newItem,
        isAddingNewItem: false
      }
    case MC_ADDING_NEW_ITEM_ERROR:
      return {
        ...state,
        isAddingNewItem: false,
        error: action.error
      }
    case MC_DELETING_ITEM:
      return {
        ...state,
        isDeletingItem: true
      }
    case MC_DELETING_ITEM_SUCCESS:
      return {
        ...state,
        isDeletingItem: false,
        activeItemId: "",
        activeItem: {
          shuffle: false,
          startingLetter: "",
          nodeTags: null
        }
      }
    case MC_DELETING_ITEM_ERROR:
      return {
        ...state,
        isDeletingItem: false,
        error: action.error
      }
    case MC_SET_ITEM_TYPE:
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          itemType: action.itemType
        }
      }
    case MC_FETCHING_PASSAGE:
      return {
        ...state,
        isFetchingPassage: true
      }
    case MC_FETCHING_PASSAGE_SUCCESS:
      return {
        ...state,
        isFetchingPassage: false
      }
    case MC_FETCHING_PASSAGE_ERROR:
      return {
        ...state,
        isFetchingPassage: false,
        error: action.error
      }

    default:
      return state
  }
}
